export default {
  filled: {
    transform: 'translate(12px, 7px) scale(0.75) !important',
  },
};
